

















































import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

import * as _ from 'lodash';

@Component({})
export default class UserMailInvalid extends Vue {

    @Getter('getCompany', { namespace: 'auth' })
    public getCompany: any;

    @Action('createSession', {namespace: 'auth'})
    public createSession: any;

    public featured_image: string;

    constructor() {
        super();

        this.featured_image = `${window.API_V1}/login/imagem-destaque`;
    }

    get company(): any {

        const { userId, companyId } = this.$route.params;

        const selectedCompany = this.getCompany({userId, companyId});

        if (_.isEmpty(selectedCompany)) {
            return this.$router.replace('/login');
        }

        return selectedCompany;
    }

    get username(): string {
        return this.company.nome_pessoa;
    }

    get email(): string {
        return this.company.email;
    }

    public proceed() {
        return this.createSession(this.company);
    }
}
